module.exports = __webpack_public_path__ + "static/billboardslider-01-min-a94b30838b870ce40699c57ac2d28624.jpg";